// Services
import breedService from "@/app/services/main/breed/breed-service.js";

// Utils
import { vuelidateUtil } from "@/utils/vuelidate-util.js";

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { dateMixins } from "@/app/mixins/utils/date-mixins";

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants";

// Third Party libraries
import DatePicker from "vue2-datepicker";

export default {
    name: 'LandingPublicProductSearch',
    components: { DatePicker },
    directive: {},
    filters: {},
    mixins: [
        toastMessageMixins,
        dateMixins,
    ],
    props: {},
    data() {
        return {

            isAPILoading: false,

            breedList: [],

            displayedBreedName: "",
            inputtedPetName: "",
            displayedPetName: "",

            filters: { petBirth: "", selectedBreed: null },
        }
    },
    computed: {
        isNativeApp() {
            return this.$store.getters.getIsNativeApp;
        },
        validationRules() {
            const fields = {
                filters: {
                    selectedBreed: {},
                    petBirth: {},
                },
            };

            fields.filters = vuelidateUtil.setFieldsRequired(fields.filters, true);

            return fields;
        },
    },
    watch: {},
    async created() {
        try {
            this.isAPILoading = true;
            await this.getBreedList();
            
        } catch (err) {
            this.showGenericErrorToast();
        } finally {
            this.isAPILoading = false;
        }

        window.scrollTo(0, 0);
    },
    methods: {
       
        async getBreedList() {
            try {
                const breedsResponse = await breedService.getBreeds();

                if (breedsResponse.status === STATUS_CODES.SUCCESS) {
                    const otherBreedOptions = breedsResponse.data.data.slice(0, 4);
                    const breeds = this.sortAlphabetically(breedsResponse.data.data.slice(4, breedsResponse.data.count));

                    // remove "Breed not specified", it has id = 0
                    this.breedList = [...otherBreedOptions, ...breeds].filter((breed) => breed.id != 0);
                } else {
                    const { ERROR_GET_BREED_LIST } = this.toastMessages.breed();
                    this.showAPIErrorToast(ERROR_GET_BREED_LIST, breedsResponse);
                }
            } catch (err) {
                this.showGenericErrorToast();
            }
        },
       
        async searchProducts() {
            const { selectedBreed, petBirth } = this.filters;

            if (!selectedBreed) {
                this.$v.filters.selectedBreed.$touch(); // will triger validation
            }

            if (!petBirth) {
                this.$v.filters.petBirth.$touch(); // will triger validation
            }

            if (!selectedBreed || !petBirth) {
                return;
            }

            if (this.inputtedPetName) {
                const capitalizedPetName =
                    this.inputtedPetName.charAt(0).toUpperCase() + this.inputtedPetName.slice(1).toLowerCase();
                    this.displayedPetName = capitalizedPetName;
            } else {
                this.displayedPetName = "";
            }

            this.$router.push({
                path: '/public-products',
                query: {
                    breedId: selectedBreed.id,
                    petBirth:  this.formatDate(petBirth),
                    petName: this.displayedPetName
                }
            });
        },
       
        sortAlphabetically(items) {
            const sortedItems = items.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            return sortedItems;
        },

        notAfterToday(date) {
            return date > new Date();
        },
        
    },
    validations() {
        return this.validationRules;
    },
    // third party libraries
}